import type { GetServerSidePropsContext, NextPageContext } from 'next'
import Cookies from 'cookie-universal'
import { COOKIE_NAMES } from './cookies'
import { getMcUserIdFromToken } from './tokenUserId'

type Ctx = Pick<GetServerSidePropsContext | NextPageContext, 'req' | 'res'>

export const getMcUserIdFromCtx = async (ctx: Ctx): Promise<string | null> => {
  const { req, res } = ctx
  if (!req || !res) return null

  const accessToken = Cookies(req, res).get(COOKIE_NAMES.ACCESS_TOKEN)
  if (typeof accessToken !== 'string') return null

  return getMcUserIdFromToken(accessToken)
}
